export const isLastInstanceOfChapter = (treeData:any, chapter:any) => {
    let chapterId =  (chapter && chapter.id) || (chapter && chapter.chapter && chapter.chapter.id)
    let duplicateChaptersArray: any = [];
    let updatedTreeData = JSON.parse(JSON.stringify(treeData));
    const { phases } = updatedTreeData;
    phases.forEach((phase:any, phaseNumber: number) => {
        const { weeks } = phase;
        weeks.forEach((week:any, weekNumber: number) => {
            const { subjects } = week;
            subjects.forEach((subject:any, subjectNumber: number) => {
                const { chapters } = subject;
                
                chapters.forEach((chap:any, chapterNumber: number) => {
                    if(chap.id === chapterId){
                        let chapterArray = {
                            chapterIndex: chapterNumber,
                            subjectIndex: subjectNumber,
                            weekIndex: weekNumber,
                            phaseIndex: phaseNumber,
                            data: chap
                        }
                        duplicateChaptersArray.push(chapterArray)

                    }
                })
            })
        })
    })
    let orgContentData: any=[];
    duplicateChaptersArray.map((dupEle: any, index: number) => {
        if(index !== duplicateChaptersArray.length -1 ) {
            if(dupEle.data && dupEle.data.content) {
                orgContentData = dupEle.data.content;
                dupEle.data.content = []
            }
            dupEle.showChapterLevelContent = false;
            updatedTreeData.phases[dupEle.phaseIndex].weeks[dupEle.weekIndex].subjects[dupEle.subjectIndex].chapters[dupEle.chapterIndex] = dupEle.data;
            updatedTreeData.phases[dupEle.phaseIndex].weeks[dupEle.weekIndex].subjects[dupEle.subjectIndex].chapters[dupEle.chapterIndex].hideChapterLevel = true


        } else {
            updatedTreeData.phases[dupEle.phaseIndex].weeks[dupEle.weekIndex].subjects[dupEle.subjectIndex].chapters[dupEle.chapterIndex].content = orgContentData
            updatedTreeData.phases[dupEle.phaseIndex].weeks[dupEle.weekIndex].subjects[dupEle.subjectIndex].chapters[dupEle.chapterIndex].hideChapterLevel = false;
            updatedTreeData.phases[dupEle.phaseIndex].weeks[dupEle.weekIndex].subjects[dupEle.subjectIndex].chapters.push(updatedTreeData.phases[dupEle.phaseIndex].weeks[dupEle.weekIndex].subjects[dupEle.subjectIndex].chapters.splice(dupEle.chapterIndex, 1)[0]);
        }
    })

    updatedTreeData.phases.map((phaseData: any) => {
        phaseData.subjects.map((subject: any) => {
            let subChapter: any = []
            phaseData.weeks.map((weekData: any) => {
                weekData.subjects.map((subData: any) => {
                    if(subject.id === subData.id) {
                        subData.chapters.map((chapData: any) => {
                            subChapter.push(chapData)

                        })
                    }


                })
            })
            const filteredArr = subChapter.reduce((acc: any, current: any) => {
                const x = acc.find((item: any) => item.id === current.id);
                if (!x) {
                  return acc.concat([current]);
                } else {
                  return acc;
                }
              }, []);

            subject.chapterCount = filteredArr.length;
            return subject
        })

    })
    return updatedTreeData;
}

export const checkForDuplicateChapters = (treeData:any) => {
    let updatedTreeData = JSON.parse(JSON.stringify(treeData));
    let chaptersIds = new Map();
    let { phases } = updatedTreeData;

    phases.forEach((phase:any, phaseNumber: number) => {
        const { weeks } = phase;
        weeks.forEach((week:any, weekNumber: number) => {
            const { subjects } = week;
            subjects.forEach((subject:any, subjectNumber: number) => {
                const { chapters } = subject;
                
                chapters.forEach((chap:any, chapterNumber: number) => {
                        if(chaptersIds.has(chap.id)) {
                            chaptersIds.set(chap.id, chaptersIds.get(chap.id) + 1);

                        } else {
                            chaptersIds.set(chap.id, 1);
                        }
                    
                })
            })
        })
     })

     phases = phases.map((phase:any, phaseNumber: number) => {
        const { weeks } = phase;
        weeks.map((week:any, weekNumber: number) => {
            const { subjects } = week;
            subjects.map((subject:any, subjectNumber: number) => {
                const { chapters } = subject;

                let count = 1
                
                chapters.map((chap:any, chapterNumber: number) => {
                        if(chaptersIds.has(chap.id) && count == chaptersIds.get(chap.id)) { 
                            chap.hideChapterLevel = false; 

                        } else {
                            chap.hideChapterLevel = true; 
                            chaptersIds.set(chap.id, chaptersIds.get(chap.id) - 1);
       

                        }
                        return chap
                    
                })
                return subject
            })
            return week
        })
        return phase
     })

     updatedTreeData.phases = phases
     return updatedTreeData

}